import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const StickyBanner = () => {
  const { t } = useLanguage();
  
  return (
    <a 
      href="https://roobet.com/?ref=fastbonus" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="sticky-banner"
    >
      <span>🎁 {t('bannerText')}</span>
    </a>
  );
};

export default StickyBanner;
